import { Component } from "@angular/core";

@Component({
	selector: "app-private-cookie",
	templateUrl: "./private-cookie.component.html",
	styleUrl: "./private-cookie.component.scss",
	standalone: false
})
export class PrivateCookieComponent { }